import React, { PureComponent } from "react";
import OneColumnLayout from "../../layouts/one-column";
import IncomeStatementWidget from "../../../finance/widgets/income-statement";

class TeamReportsSection7Step1 extends PureComponent {
  get content() {
    const { incomeStatement, current_year } = this.props;

    return (
      <IncomeStatementWidget
        incomeStatement={incomeStatement}
        current_year={current_year}
        className="team-reports-with-scroll-2"
      />
    );
  }

  render() {
    return <OneColumnLayout title="Income Statement" content={this.content} />;
  }
}

export default TeamReportsSection7Step1;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-7/step-2.js